module.exports = __webpack_public_path__ + "images/22cbc9d665d60e0d6bb676f935a38f0b.png";